module.exports = __webpack_public_path__ + "static/media/Noimageset.a417e649.png";